export const FLAT_POPUP_INIT = 'FLAT_POPUP_INIT'
export const FLAT_POPUP_ADD_FLAT = 'FLAT_POPUP_ADD_FLAT'
export const FLAT_POPUP_ADDED_FLAT = 'FLAT_POPUP_ADDED_FLAT'
export const FLAT_POPUP_ERROR = 'FLAT_POPUP_ERROR'
